import { render } from "./PromptsManagement.vue?vue&type=template&id=7daf39b4"
import script from "./PromptsManagement.vue?vue&type=script&lang=js"
export * from "./PromptsManagement.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__